import { IconArrowDown } from '@lmn/lastminute-react-icons/lastminute-icons-linear';
import styled, { css, keyframes } from 'styled-components';
import { color, font } from "../../../../themes/mixins/Fonts.js";
import { spacing } from "../../../../themes/mixins/Spacings.js";
import { Menu, MenuItem, MenuItemStyles, MenuStyles } from "../../Menu/index.js";
import { FormFieldStyles } from "../FormField.styles.js";
import { SelectField } from "./SelectField.js";
var SelectFieldStyled = /*#__PURE__*/styled(SelectField).withConfig({
  displayName: "Selectstyles__SelectFieldStyled",
  componentId: "sc-d5yk3i-0"
})(["& ", "{cursor:pointer;}"], FormFieldStyles.InnerWrapper);
var IconArrow = /*#__PURE__*/styled(IconArrowDown).withConfig({
  displayName: "Selectstyles__IconArrow",
  componentId: "sc-d5yk3i-1"
})(["", ";", ";"], function (_ref) {
  var $isFlipped = _ref.$isFlipped;
  return $isFlipped ? 'transform: rotate(180deg)' : '';
}, function (_ref2) {
  var $disabled = _ref2.$disabled,
    theme = _ref2.theme;
  return $disabled ? "fill: ".concat(theme.commons.colors.gray200, ";") : '';
});
var InnerWrapper = /*#__PURE__*/styled(FormFieldStyles.InnerWrapper).withConfig({
  displayName: "Selectstyles__InnerWrapper",
  componentId: "sc-d5yk3i-2"
})(["padding-top:0;padding-bottom:0;font-family:", ";border:0;text-align:left;cursor:pointer;", " ", " ", ""], function (_ref3) {
  var theme = _ref3.theme;
  return theme.commons.font.family;
}, function (_ref4) {
  var $hasError = _ref4.$hasError,
    $isShownAsFocused = _ref4.$isShownAsFocused;
  return !$hasError && $isShownAsFocused ? FormFieldStyles.innerWrapperFocusedCss : '';
}, function (_ref5) {
  var $isLabelShrunk = _ref5.$isLabelShrunk,
    $placeholder = _ref5.$placeholder;
  return $isLabelShrunk ? css(["& ", "{", "}"], FormFieldStyles.LabelText, $placeholder ? FormFieldStyles.hiddenLabel : FormFieldStyles.labelTextShrunkCss) : '';
}, function (_ref6) {
  var $disabled = _ref6.$disabled;
  return $disabled && 'pointer-events: none;';
});
var ValueWrapper = /*#__PURE__*/styled(FormFieldStyles.ValueWrapper).withConfig({
  displayName: "Selectstyles__ValueWrapper",
  componentId: "sc-d5yk3i-3"
})(["min-height:", "px;height:100%;"], FormFieldStyles.DEFAULT_FORM_FIELD_HEIGHT);
var AccessibleLabel = /*#__PURE__*/styled.label.withConfig({
  displayName: "Selectstyles__AccessibleLabel",
  componentId: "sc-d5yk3i-4"
})(["border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;"]);
var HiddenInput = /*#__PURE__*/styled.input.withConfig({
  displayName: "Selectstyles__HiddenInput",
  componentId: "sc-d5yk3i-5"
})(["width:0;border:0;padding:0;"]);
var SelectedOption = /*#__PURE__*/styled.span.withConfig({
  displayName: "Selectstyles__SelectedOption",
  componentId: "sc-d5yk3i-6"
})(["margin-top:", ";display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:", ";font-weight:", ";line-height:", ";"], function (_ref7) {
  var $placeholder = _ref7.$placeholder;
  return $placeholder ? '18px' : '24px';
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.commons.font.sizes.medium;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.commons.font.weights.regular;
}, function (_ref0) {
  var theme = _ref0.theme;
  return theme.commons.font.heights.base;
});
var MenuStyled = /*#__PURE__*/styled(Menu).withConfig({
  displayName: "Selectstyles__MenuStyled",
  componentId: "sc-d5yk3i-7"
})(["& .", "{", " margin-left:-1px;", " ", "}"], MenuStyles.paperClassName, function (_ref1) {
  var theme = _ref1.theme;
  return theme.mixins.margin({
    top: 0.5
  });
}, function (_ref10) {
  var $hasMaxHeight = _ref10.$hasMaxHeight;
  return $hasMaxHeight ? css(["max-height:264px;"]) : '';
}, function (_ref11) {
  var $minWidth = _ref11.$minWidth;
  return $minWidth ? css(["min-width:", "px;"], $minWidth) : '';
});
var menuFadeIn = /*#__PURE__*/keyframes(["from{opacity:0;transform:scale(0,0);}to{opacity:1;}"]);
var PortalMenuStyled = /*#__PURE__*/styled.div.withConfig({
  displayName: "Selectstyles__PortalMenuStyled",
  componentId: "sc-d5yk3i-8"
})(["position:absolute;top:", ";left:", ";z-index:9999;background-color:white;", " ", " ", ";transform-origin:top left;animation:", " 267ms cubic-bezier(0.4,0,0.2,1);overflow-y:auto;overflow-x:hidden;", ";", ";", ";"], function (_ref12) {
  var $top = _ref12.$top;
  return "".concat($top, "px");
}, function (_ref13) {
  var $left = _ref13.$left;
  return "".concat($left, "px");
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.mixins.borderRadius('8px');
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.mixins.elevation('large');
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.mixins.margin({
    top: 0.5
  });
}, menuFadeIn, function (_ref17) {
  var $maxHeight = _ref17.$maxHeight;
  return typeof $maxHeight !== 'undefined' ? css(["max-height:", ";"], $maxHeight) : '';
}, function (_ref18) {
  var $maxWidth = _ref18.$maxWidth;
  return typeof $maxWidth !== 'undefined' ? css(["max-width:", ";"], $maxWidth) : '';
}, function (_ref19) {
  var $minWidth = _ref19.$minWidth;
  return $minWidth ? css(["min-width:", "px;"], $minWidth) : '';
});
var SearchInputStyled = /*#__PURE__*/styled.input.withConfig({
  displayName: "Selectstyles__SearchInputStyled",
  componentId: "sc-d5yk3i-9"
})(["position:absolute;left:0;top:50%;transform:translateY(-50%);width:100%;appearance:none;outline:none;border:none;background:transparent;", " color:", ";", ""], font('TextLarge'), color('gray800'), function (_ref20) {
  var theme = _ref20.theme;
  return theme.mixins.padding({
    top: 2
  });
});
var ListSubheaderStyled = /*#__PURE__*/styled.li.attrs({
  role: 'presentation'
}).withConfig({
  displayName: "Selectstyles__ListSubheaderStyled",
  componentId: "sc-d5yk3i-10"
})(["list-style:none;background:transparent;", " line-height:24px;", " font-weight:", ";"], function (_ref21) {
  var theme = _ref21.theme;
  return theme.mixins.padding({
    top: 1,
    hor: 2
  });
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.mixins.font('TextLarge');
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.commons.font.weights.bold;
});

// LEGACY: Only needed while `legacyMUIMenuEnabled` path exists.
// MUI MenuList checks this static prop to skip non-option children during keyboard navigation.
// Remove together with the legacy MUI menu path.
ListSubheaderStyled.muiSkipListHighlight = true;
var GroupDivider = /*#__PURE__*/styled.div.withConfig({
  displayName: "Selectstyles__GroupDivider",
  componentId: "sc-d5yk3i-11"
})(["border-bottom:1px solid ", ";margin-bottom:8px;margin-top:", ";"], function (_ref24) {
  var theme = _ref24.theme;
  return theme.commons.colors.gray200;
}, function (_ref25) {
  var marginTop = _ref25.marginTop;
  return marginTop ? '8px' : 0;
});
var MenuItemStyled = /*#__PURE__*/styled(MenuItem).withConfig({
  displayName: "Selectstyles__MenuItemStyled",
  componentId: "sc-d5yk3i-12"
})(["display:flex;overflow:hidden;width:100%;gap:", ";&.MuiMenuItem-root{", " &:last-child{", "}&.active{background-color:", ";}}& ", "{flex:1 1 auto;overflow:hidden;min-width:0;white-space:nowrap;text-overflow:ellipsis;", ";}& ", "{", " flex:0 0 auto;}"], spacing(1), function (_ref26) {
  var theme = _ref26.theme;
  return theme.mixins.margin({
    ver: 0
  });
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.mixins.margin({
    ver: 0
  });
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.commons.colors.gray50;
}, MenuItemStyles.Label, function (_ref29) {
  var theme = _ref29.theme;
  return theme.mixins.margin(0);
}, MenuItemStyles.SelectedIcon, function (_ref30) {
  var selected = _ref30.selected;
  return !selected && css(["display:none;"]);
});
export var SelectStyles = {
  Wrapper: FormFieldStyles.Wrapper,
  LabelText: FormFieldStyles.LabelText,
  AdornmentWrapper: FormFieldStyles.AdornmentWrapper,
  ExtraDescription: FormFieldStyles.ExtraDescription,
  HelperText: FormFieldStyles.HelperText,
  SelectFieldStyled: SelectFieldStyled,
  MenuStyled: MenuStyled,
  MenuItemStyled: MenuItemStyled,
  PortalMenuStyled: PortalMenuStyled,
  SearchInputStyled: SearchInputStyled,
  IconArrow: IconArrow,
  InnerWrapper: InnerWrapper,
  ValueWrapper: ValueWrapper,
  AccessibleLabel: AccessibleLabel,
  HiddenInput: HiddenInput,
  SelectedOption: SelectedOption,
  ListSubheaderStyled: ListSubheaderStyled,
  GroupDivider: GroupDivider
};